<template>
    <v-dialog v-model="dialog" max-width="450" persistent>
        <template v-slot:activator="{ on }">
            <v-btn
                   style="position: absolute; top:0;right:90px;margin: 5px"
                   fab
                   x-small depressed
                   v-on="on"
                   :color="color"
            >
                <v-icon color="white">{{icons.share}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>Share to User
                <v-spacer></v-spacer>
                <v-btn icon small @click="Close()">
                    <v-icon>{{icons.close}}</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-text-field outlined dense label="Search Users" v-model="string" @input="searchUsers()" clearable />
                <v-list>
                    <v-list-item v-for="u in users" @click="confirmShare(u)">
                        <v-list-item-avatar>
                            <v-img :src="u.picture || 'https://athleteforlife.org/static/volleyhead.jpg'" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{u.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{u.email}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-text-field color="info" class="subtitle-2" v-text="src" ref="textsrc" :append-outer-icon="icons.link"/>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">
                    Close
                </v-btn>
                <v-spacer/>
                <v-btn v-if="dev" icon large @click="shareToFacebook(src)">
                    <v-icon color="#3B5998">mdi-facebook</v-icon>
                </v-btn>
                <v-btn v-if="dev" text @click="OsShare()">
                    <v-icon>{{icons.share}}</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "ShareVideo",
    props: ['src','color'],
    components: {},
    data() {
      return {
        dialog: false,
        string:'',
        users: undefined,
        sharing:false
      }
    },
    computed: {
      ...mapState(['icons','dev','activevideo'])
    },
    methods: {
      ...mapActions(['get', 'post']),
      Close() {
        this.users=undefined
        this.string=''
        this.dialog = false
      },
      async searchUsers(){
        if(!this.string || this.string.length<2){
          this.users = undefined;
          return
        }
        let res = await this.post({path:'api/users/typesearchbystring', body:{string: this.string}})
        this.users = res
      },
      confirmShare(u){
        this.sharing=true
        let data = {
          activevideo:this.activevideo,
          usersub:u.username
        }
        let rsp = this.post({path: 'api/video/sharewith',body:data})
        this.sharing=false
        this.dialog=false
        this.string=''
        this.users=undefined
      },
      OsShare(){
        console.log(navigator)
        if (navigator.share) {
          navigator.share({
            title: 'video',
            text: 'Check out video...',
            url: this.src,
          })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing', error));
        }

        // let file = URL.createObjectURL(new File([this.src], `video.mp4`, {type: "video/mp4"}));
        //
        // if (navigator.canShare && navigator.canShare({ files: [file] })) {
        //   navigator.share({
        //     files: [file],
        //     title: 'Vacation Pictures',
        //     text: 'Photos from September 27 to October 14.',
        //   })
        //     .then(() => console.log('Share was successful.'))
        //     .catch((error) => console.log('Sharing failed', error));
        // } else {
        //   alert(`Your system doesn't support sharing files.`);
        // }
      }
    }
  }
</script>

<style scoped>

</style>